/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_DashboardInputs */

const en_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD Import Dashboard`)
};

const fr_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord d'importation AD`)
};

const de_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Import-Dashboard`)
};

const it_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard di importazione AD`)
};

const ru_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления импортом AD`)
};

const es_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de importación de AD`)
};

const zh_cn2_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告导入仪表板`)
};

const ja_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告インポートダッシュボード`)
};

const hi_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD आयात डैशबोर्ड`)
};

const pt_pt2_ad_import_dashboard = /** @type {(inputs: Ad_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de Importação de Anúncios`)
};

/**
* | output |
* | --- |
* | "AD Import Dashboard" |
*
* @param {Ad_Import_DashboardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_dashboard = /** @type {((inputs?: Ad_Import_DashboardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_DashboardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_import_dashboard(inputs)
	if (locale === "de") return de_ad_import_dashboard(inputs)
	if (locale === "it") return it_ad_import_dashboard(inputs)
	if (locale === "ru") return ru_ad_import_dashboard(inputs)
	if (locale === "es") return es_ad_import_dashboard(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_import_dashboard(inputs)
	if (locale === "ja") return ja_ad_import_dashboard(inputs)
	if (locale === "hi") return hi_ad_import_dashboard(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_import_dashboard(inputs)
	return en_ad_import_dashboard(inputs)
});